module.exports = __webpack_public_path__ + "static/media/arrow-back.e51e02d0.svg";